import Logger from "@/core/Logger";

// services/exceptions/ApiException.ts
export class ApiException extends Error {
  public statusCode: number;
  public details?: unknown;

  constructor(message: string, statusCode: number, details?: unknown) {
    Logger.error(message, { statusCode, details });
    super(message);
    this.name = "ApiException";
    this.statusCode = statusCode;
    this.details = details;
  }
}
